import { appRouterPaths } from 'services/navigation';
import { BuildingsPage } from 'pages/Buildings';
import { BuildingPage } from 'pages/Building';
import type { AppRouteProps } from '../types';

export const buildingsPageRoute: AppRouteProps = {
  path: appRouterPaths.buildings,
  element: <BuildingsPage />,
};

export const buildingPageRoute: AppRouteProps = {
  path: appRouterPaths.building,
  element: <BuildingPage />,
};
